import React from "react";
import { Check } from "lucide-react";
import { TEAL } from "./constant";
import { useT } from "providers/I18nProvider";

/**
 * Section #dang-ky: cột trái teal (cam kết + số liệu + liên hệ), cột phải = form (children).
 * Tách riêng để container chỉ giữ logic gửi.
 */
const RegisterSection: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const t = useT();
  const promises = [t("partner.promise1"), t("partner.promise2"), t("partner.promise3")];
  const stats: Array<[string, string]> = [
    ["1.000++", t("partner.stat1Label")],
    ["24/7", t("partner.stat2Label")],
    ["Top 15", t("partner.stat3Label")],
  ];
  return (
    <section id="dang-ky" className="scroll-mt-24 bg-gradient-to-b from-[#eefbfb] to-white">
      <div className="container mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid lg:grid-cols-[0.85fr_1fr] gap-8 items-start">
          <div
            className="rounded-3xl p-7 md:p-9 text-white lg:sticky lg:top-24"
            style={{ background: `linear-gradient(160deg, ${TEAL} 0%, #127a86 100%)` }}
          >
            <h2 className="text-[26px] md:text-[32px] font-extrabold text-white">{t("partner.registerTitle")}</h2>
            <p className="text-white/85 mt-2 leading-relaxed">{t("partner.registerDesc")}</p>

            <ul className="mt-7 space-y-3.5">
              {promises.map((text) => (
                <li key={text} className="flex items-start gap-3 text-[15px] text-white/95">
                  <span className="mt-[2px] flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-white/20">
                    <Check size={12} strokeWidth={3} aria-hidden="true" />
                  </span>
                  <span>{text}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 border-t border-white/20 pt-7">
              <div className="grid grid-cols-3 gap-3">
                {stats.map(([big, small]) => (
                  <div
                    key={small}
                    className="rounded-2xl bg-white/12 border border-white/20 px-3 py-2.5 text-center"
                  >
                    <p className="text-lg font-extrabold !mb-0 text-white">{big}</p>
                    <p className="text-[12px] text-white/80 !mb-0">{small}</p>
                  </div>
                ))}
              </div>
              <p className="mt-5 text-[14px] text-white/85 !mb-0">
                {t("partner.contactPrompt")}{" "}
                <a
                  href="mailto:support@lookme.vn"
                  className="inline-flex min-h-6 items-center font-bold text-white underline underline-offset-4"
                >
                  support@lookme.vn
                </a>
              </p>
            </div>
          </div>

          <div className="rounded-3xl bg-white border border-[#d8f3f2] shadow-xl p-6 md:p-8">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default RegisterSection;
